export default "__VITE_ASSET__CAP9gGaI__"